import { Injectable } from '@angular/core';

@Injectable()
export class RegexService {
  public isDecimalOrNegative(numberToCheck: number = null): boolean {
    if (numberToCheck == null) {
      return false;
    } else {
      const myRegexNoDecimal = new RegExp(/^\d+$/, 'i');
      if (!myRegexNoDecimal.test(numberToCheck.toString())) {
        return true;
      }
    }
    return false;
  }

  public isMiloCode(value: string = null): boolean {
    if (value == null) {
      return false;
    } else {
      const regex = new RegExp(/^[C0-9][0-9]{5}$/, 'i');
      if (regex.test(value.toString())) {
        return true;
      }
    }
    return false;
  }

  public isAmount(value: string = null): boolean {
    if (value == null) {
      return false;
    } else {
      const regex = new RegExp(/^\d+\.?\d*$/, 'i');
      if (regex.test(value.toString())) {
        return true;
      }
    }
    return false;
  }

  public isYesNo(value: string = null): boolean {
    if (value == null) {
      return false;
    } else {
      const regex = new RegExp(/^(y|Y|n|N|o|O)$/, 'i');
      if (regex.test(value.toString())) {
        return true;
      }
    }
    return false;
  }

  public isFinancialCondition(value: string = null): boolean {
    if (value == null) {
      return false;
    } else {
      const regex = new RegExp(/^(f|F|s|S|g|G)$/, 'i');
      if (regex.test(value.toString())) {
        return true;
      }
    }
    return false;
  }

  public isOrderNumber(value: string = null): boolean {
    if (value == null) {
      return false;
    } else {
      const regex = new RegExp(
        /^[5](6|8)(2|4|9)(N|O|Y)[0-9]{1}[C0-9][0-9]{5}[0-9]{1}$/,
        'i'
      );
      if (regex.test(value.toString())) {
        return true;
      }
    }
    return false;
  }

  public isDate(value: string = null): boolean {
    if (value == null) {
      return false;
    } else {
      const regex = new RegExp(
        /^([0-9]{2}[-][0-9]{2}[-][0-9]{4}|[0-9]{4}[-][0-9]{2}[-][0-9]{2})$/,
        'i'
      );
      if (regex.test(value.toString())) {
        return true;
      }
    }
    return false;
  }
}
